import React, { Component } from "react";
import {
  withModulesManager,
  MainMenuContribution,
  formatMessage,
} from "@openimis/fe-core";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import {
  Assignment,
  People,
  Home,
  Group,
  Business,
  LocalHospital,
  HowToReg,
  PlaylistAddCheck,
} from "@material-ui/icons";

const ENROLLMENT_MAIN_MENU_CONTRIBUTION_KEY = "enrollment.MainMenu";

class EnrollmentMainMenu extends Component {
  render() {
    const { rights } = this.props;

    let entries = [];
    const BASE_ROUTE = "/enrollment";

    const homeText = formatMessage(this.props.intl, "enrollment", "menu.home");
    const insureeText = formatMessage(
      this.props.intl,
      "enrollment",
      "menu.insureeEnrollment"
    );
    const familyText = formatMessage(
      this.props.intl,
      "enrollment",
      "menu.familyEnrollment"
    );
    const policyHolderText = formatMessage(
      this.props.intl,
      "enrollment",
      "menu.policyHolderEnrollment"
    );
    const healthFacilityText = formatMessage(
      this.props.intl,
      "enrollment",
      "menu.healthFacilityEnrollment"
    );
    const accountClaimText = formatMessage(
      this.props.intl,
      "enrollment",
      "menu.accountClaimEnrollment"
    );
    const policyHolderBatchText = formatMessage(
      this.props.intl,
      "enrollment",
      "menu.policyHolderBatch"
    );

    entries.push({
      key: "enrollment-home",
      id: "enrollment.home",
      text: homeText,
      icon: <Home />,
      route: `${BASE_ROUTE}/home`,
      filter: () => true,
    });

    entries.push({
      key: "enrollment-insuree",
      id: "enrollment.insureeEnrollment",
      text: insureeText,
      icon: <People />,
      route: `${BASE_ROUTE}/insuree-enrollment`,
      filter: () => true,
    });

    entries.push({
      key: "enrollment-family",
      id: "enrollment.familyEnrollment",
      text: familyText,
      icon: <Group />,
      route: `${BASE_ROUTE}/family`,
      filter: () => true,
    });

    entries.push({
      key: "enrollment-policyholder",
      id: "enrollment.policyHolderEnrollment",
      text: policyHolderText,
      icon: <Business />,
      route: `${BASE_ROUTE}/policyholder`,
      filter: () => true,
    });

    entries.push({
      key: "enrollment-healthfacility",
      id: "enrollment.healthFacilityEnrollment",
      text: healthFacilityText,
      icon: <LocalHospital />,
      route: `${BASE_ROUTE}/healthfacility`,
      filter: () => true,
    });

    entries.push({
      key: "enrollment-account-claim",
      id: "enrollment.accountClaimEnrollment",
      text: accountClaimText,
      icon: <HowToReg />,
      route: `${BASE_ROUTE}/account-claim`,
      filter: () => true,
    });

    entries.push({
      key: "enrollment-policyholder-batch",
      id: "enrollment.policyHolderBatch",
      text: policyHolderBatchText,
      icon: <PlaylistAddCheck />,
      route: `${BASE_ROUTE}/policyholder-batch`,
      filter: () => true,
    });

    entries.push(
      ...this.props.modulesManager
        .getContribs(ENROLLMENT_MAIN_MENU_CONTRIBUTION_KEY)
        .filter((c) => !c.filter || c.filter(rights))
    );

    if (!entries.length) return null;

    return (
      <MainMenuContribution
        {...this.props}
        header={formatMessage(this.props.intl, "enrollment", "mainMenu.header")}
        icon={<Assignment />}
        entries={entries}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  rights:
    !!state.core && !!state.core.user && !!state.core.user.i_user
      ? state.core.user.i_user.rights
      : [],
});

export default withModulesManager(
  injectIntl(connect(mapStateToProps)(EnrollmentMainMenu))
);
